import { SIZE, KIND } from 'baseui/button'
import SDButton from '../../../../components/SDComponents/SDButton/SDButton'
import SDNotification from '../../../../components/SDComponents/SDNotification'
import useResendEmail from './useResendEmail'

const ResendEmailButton = () => {
  const {
    showComponent,
    disabled,
    resendEmail,
    countdown,
    buttonLabel,
    successMessage,
    errorMessage
  } = useResendEmail()

  if (!showComponent()) {
    return null
  }

  return (
    <>
      <SDButton
        size={SIZE.compact}
        kind={KIND.secondary}
        overrides={{
          BaseButton: {
            style: () => ({
              marginRight: '1rem',
            }),
          },
        }}
        onClick={event => resendEmail(event)}
        disabled={disabled}
      >
        {
          disabled
            ? `${buttonLabel} (${countdown}s)`
            : buttonLabel
        }
      </SDButton>
      {
        errorMessage
          ? <SDNotification closeable autoHideDuration={5000} type='negative'>{errorMessage}</SDNotification>
          : null
      }
      {
        successMessage
          ? <SDNotification closeable autoHideDuration={5000} type='positive'>{successMessage}</SDNotification>
          : null
      }
    </>
  )
}

export default ResendEmailButton